import React, { useRef, useEffect, useState } from 'react';
import { GameTypeProps, PronunciationProps } from '@/types/game';
import classNames from './Pronunciation.module.scss';
import SVG from 'react-inlinesvg';
import classes from 'classnames';
import soundPlay from '@/assets/svg/speaker.svg';
import pauseIcon from '@/assets/svg/pause.svg';
import PronunciationMicrophone from './PronunciationMicrophoneNew/PronunciationMicrophone';
import UseScreenSize from '@/hooks/UseScreenSize';
import { gameSelector } from '@/store/reducers/game';
import { useAppSelector } from '@/store';
import commonUtils from '@/utils/common';
import { studyingLanguageSelector } from '@/store/reducers/auth';
import { useTranslation } from 'react-i18next';
import { authSelector } from '@/store/reducers/auth';

const Pronunciation = ({
  currentQuestion,
  pickedAnswer,
  emitOnRetry,
  emitOnAnswer,
  emitOnNextQuestion,
}: GameTypeProps & PronunciationProps) => {
  const { t } = useTranslation();
  const { isDesktop } = UseScreenSize();
  const { selectedQuiz, revealTranslation, skipSpeechRecordingQuestions } =
    useAppSelector(gameSelector);
  const [isListening, setIsListening] = useState(false);
  const studyingLanguage = useAppSelector(studyingLanguageSelector);
  const [isPlaying, setIsPlaying] = useState(false);
  const { nativeLanguage } = useAppSelector(authSelector);
  const audioRef = useRef<HTMLAudioElement | null>(null); // Use a ref to keep track of the audio instance

  const onPlaySound = () => {
    if (!currentQuestion.answer) return;

    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    } else {
      const audio = new Audio(currentQuestion.answer);
      audioRef.current = audio;

      audio.play();
      setIsPlaying(true);

      audio.onended = () => {
        setIsPlaying(false);
        audioRef.current = null;
      };
    }
  };
  const checkIfIsListening = (isListening: boolean) => {
    setIsListening(isListening);
  };
  useEffect(() => {}, [revealTranslation]);
  const instructionData = commonUtils.getQuestionInstructions(
    currentQuestion,
    nativeLanguage,
    selectedQuiz
  );

  if (skipSpeechRecordingQuestions) {
    return <></>;
  }

  return (
    <div className={classNames.pronunciation}>
      {isDesktop && selectedQuiz && (
        <h2
          className={classes(classNames.instructions, [
            classNames[`instructions-${instructionData.direction}`],
          ])}
        >
          {instructionData.instructions}
        </h2>
      )}
      <div className={classNames.content}>
        <div
          className={classNames.top}
          style={{
            direction: (studyingLanguage?.direction as React.CSSProperties['direction']) ?? 'ltr',
          }}
        >
          {currentQuestion.answer && (
            <>
              <button
                disabled={isListening}
                className={classes(classNames.soundBtn, {
                  [classNames.soundBtnDisabled]: isListening,
                })}
                onClick={onPlaySound}
                aria-label={t('play_sound') || ''}
              >
                <SVG className={classNames.svg} src={isPlaying ? pauseIcon : soundPlay} />
              </button>
            </>
          )}
          <h2>{currentQuestion.question}</h2>
        </div>
        {revealTranslation && <div>{currentQuestion.targetWordTranslation ?? ''}</div>}
        <PronunciationMicrophone
          currentQuestion={currentQuestion}
          pickedAnswer={pickedAnswer}
          checkIfIsListening={checkIfIsListening}
          emitOnRetry={emitOnRetry}
          emitOnAnswer={emitOnAnswer}
          emitOnNextQuestion={emitOnNextQuestion}
        />
      </div>
    </div>
  );
};

export default Pronunciation;
